/* lm-footer-overlays — opens/closes the footer overlays (Social, Documentation). A footer link with
   data-lm-overlay-open="social|documentation" opens #overlay-<key>. Closes on backdrop click or Esc,
   and locks body scroll while open. Replaces the old single-purpose social-overlay.js. */
(function () {
  'use strict';

  function byKey(key) { return document.getElementById('overlay-' + key); }
  function open(o) {
    if (!o) return;
    // never stack overlays — close any other that happens to be open first
    document.querySelectorAll('[data-lm-overlay].is-open').forEach(function (x) { if (x !== o) x.classList.remove('is-open'); });
    o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close(o) {
    if (!o) return;
    o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-lm-overlay-open]').forEach(function (btn) {
    var key = btn.getAttribute('data-lm-overlay-open');
    btn.addEventListener('click', function (e) { e.preventDefault(); open(byKey(key)); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(byKey(key)); }
    });
  });

  document.querySelectorAll('[data-lm-overlay]').forEach(function (o) {
    // close only when the backdrop itself is clicked, so links inside stay clickable
    o.addEventListener('click', function (e) { if (e.target === o) close(o); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-lm-overlay].is-open').forEach(close);
    }
  });
})();
